import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  constructor(private http: HttpClient,
              private router: Router) {
  }

  postPushMobileData(hotelID: number) {
    return new Promise((resolve, reject) => {
      this.http.post(environment.baseURL + '/v2/api' + '/push_mobile_data/' + hotelID, {}).subscribe(
        () => {
          resolve(true);
        },
        (err) => {
          console.log(err);
          resolve(false);
        }
      );
    });
  }
}
